// @ts-nocheck

/**
 * * `cover_spread` - Cover Spread
 * `front_inside_spread` - Front Inside Spread
 * `spread` - Spread
 * `back_inside_spread` - Back Inside Spread
 */
export type SlideTypeEnum = typeof SlideTypeEnum[keyof typeof SlideTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SlideTypeEnum = {
  cover_spread: "cover_spread",
  front_inside_spread: "front_inside_spread",
  spread: "spread",
  back_inside_spread: "back_inside_spread",
} as const;
